import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild, OnInit,ViewChildren, QueryList, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef, NgbModule, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { BudgetGenerateService } from '@services/budget-generate.service';
import { Entity } from '@model/entity.model';
import Swal from 'sweetalert2'
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { LOCALE_ID } from '@angular/core';
import { NumberFormatDirective } from 'app/directives/number-format.directive';
import { FilterModel } from './filter.model';
import { SettingFieldAccountComponent } from './setting-field-account/setting-field-account.component';
import { SettingFieldDepartamentComponent } from './setting-field-departament/setting-field-departament.component';
import { saveAs } from 'file-saver';
import { Workbook } from 'exceljs';
import { ActivatedRoute } from '@angular/router';
import { BudgetOverViewComponent } from '../budget-over-view/budget-over-view.component';

@Component({
  selector: 'app-departament-account',
  standalone: true,
  imports: [DecimalPipe, NgSelectModule, FormsModule, NumberFormatDirective, NgbModule, CommonModule,
     SettingFieldAccountComponent,SettingFieldDepartamentComponent,BudgetOverViewComponent,],
  providers: [NgbModal, { provide: LOCALE_ID, useValue: 'es-ES' }],
  templateUrl: './departament-account.component.html',
  styleUrl: './departament-account.component.css'
})
export class DepartamentAccountComponent implements OnInit {
  @ViewChild('modal_account', { static: true }) modalAccount: any;
  @ViewChild('modal_setting', { static: true }) modalSetting: any;
  @ViewChildren(NgbPopover) popovers!: QueryList<NgbPopover>;
 
  @ViewChild('tableData', { static: true }) tableData!: ElementRef;
  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  public ngSelectedOld: string;
  public inputOld;
  private entitySelected: Entity;
  private budgetVersionSelected;
  public codeEntity;
  public txtFindAccount;
  public budgetGenerateService= inject(BudgetGenerateService)
  public accounts = [];
  public accountsTemp;
  public fieldName=[];
  fieldNameTemp;
  public dataListAccounts;
  public subtotal;
  public filter: FilterModel = new FilterModel();
  public navTab = 'dependientes'
  public rows =Array.from({length: 15}, (_, i) => i + 1);
  public cols =Array.from({length: 4}, (_, i) => i + 1);
  public isLoading = true;
  public activeSettingAccount=false;
  public activeSettingDepartament=false;
  public title='Presupuesto'
  public selectedDepartament;
  public dataListDepartament;
  public items;
  timeoutUnselect: any;
  public budgetFund;
  public fundSelect;
  public budgetStatus;
  public itemsTemp;
  activeTooltip=false;
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  txtFindDepartament;
  setFirtDepartament=0;


  constructor(private modalService: NgbModal,private route: ActivatedRoute

  ) {


    effect(() => {
      this.entitySelected = this.userService.sharingEntity();
    })
    effect(()=> {
			this.budgetVersionSelected = this.userService.sharingBudgetVersion()
      const budgetFundData = this.userService.sharingBudgetFund();
        if (this.budgetVersionSelected?.year) { 
          this.budgetFund = budgetFundData;
          this.fundSelect = this.budgetFund[0]?.fundCode;
          this.budgetStatus = this.budgetVersionSelected.status;
          this.filter.year = this.budgetVersionSelected.year;
          this.filter.version = this.budgetVersionSelected.version; 
          this.changeFilter();
        
      }
		})

  }

  

  ngOnInit() {
    /**aqui podemos recibir los valores desde la tabla budget_version */
     
  }

  //negative
negative(event: KeyboardEvent){
  const charCode = event.which ? event.which : event.keyCode;
}


coditionalNegativeSymbol(input){
  return input.value.includes('-') || input.selectionStart !== 0
}

setCharCode(event){
  return event.which ? event.which : event.keyCode;
}
  onlyNumber(event: KeyboardEvent) {
    const charCode = this.setCharCode(event)
    const input = event.target as HTMLInputElement;
    if (
      [8, 9, 37, 39, 46, 48,49,50,51,52,53,54,55,56,57].includes(charCode)
    ) {
      return;
    }
  
    // Permitir el signo negativo solo al inicio
    if (charCode === 45) {
      if (this.coditionalNegativeSymbol(input)) {
        event.preventDefault();
      }
      return;
    }
  
  }
  

  changeFilter(){
    this.route.paramMap.subscribe(params => {
      this.filter.departamentItemCode=params.get('departamentItemCode') || '';
      this.activeSettingAccount=false;
      this.activeSettingDepartament=false;
      this.setFirtDepartament=0;
      this.txtFindAccount=[];
      this.txtFindDepartament=[];
      this.getDepartamentAccount();
      this.getResumen();     
    });
  }


  openModalSettingAccount() {
    this.activeSettingAccount=true;
  }

  openModalSettingDepartament() {
    this.activeSettingDepartament=true;
  }

  /*abre los modales */
  open(content, size?) {
    this.modalRef = this.modalService.open(content, size);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  changeSettingAccount(){
    this.activeSettingAccount=false;
    this.setFirtDepartament=0;
    this.getDepartamentAccount()
    this.getResumen();
  }


  changeSettingDepartament(){
    this.activeSettingDepartament=false;
    this.setFirtDepartament=0;
    this.getDepartamentAccount()
    this.getResumen();
  }




    /**Selecciona todo el texto del input */
  
  selectAll(event,account,parentCode,departamentCode,departamentFundCode) {
    if (this.timeoutUnselect) {
      clearTimeout(this.timeoutUnselect);
      this.timeoutUnselect = null;
    }  

    const inputElement = event.target as HTMLInputElement;
    inputElement.select();
    this.toggleInput(inputElement.value);
    if(this.entitySelected?.group!='IASD'){
    const subDepartament=this.findGroupByParentCode(account.departaments, parentCode)?.subDepartaments;    
    const departament=this.findDepartament(departamentCode,subDepartament,departamentFundCode);
    this.selectedDepartament = departament;
    }
  }

    unSelectedDepartamentCode(){
      if(this.entitySelected?.group!='IASD'){
      this.timeoutUnselect = setTimeout(() => {
        
        this.selectedDepartament = undefined;
      }, 200);
    }
    }

    

    

  changeValue(event,account,parentCode,departamentCode,departamentFundCode){  
    if (Number(this.budgetStatus) !== 2) {
      return;
    }
    let value = event.target.value.replace(/\./g, '').replace('.', ',');
    value=value===''?0:value;

    const subDepartament=this.findGroupByParentCode(account.departaments, parentCode)?.subDepartaments;
    const departament=this.findDepartament(departamentCode,subDepartament,departamentFundCode);
    this.budgetGenerateService.updateDepartamentAccount({ id: departament.id, value: value }).subscribe({
      next: (res) => {
        this.getDepartamentAccount();
        this.getResumen();
        delete this.filter.id;
        this.notification('Actualizado');
      },
      error: (err) => {
        console.error('Error al actualizar cuenta departamental:', err);
        Swal.fire({
          icon: 'error',
          title: 'Presupuesto no editable',
          text: err.error?.error || err.error?.message || 'El presupuesto no está abierto. Solo se permiten modificaciones en estado Proceso (Abierto).'
        });
        this.getDepartamentAccount();
      }
    });
  }

  /*al momento de dar un click almacena el valor anterior del input en otra funcion se compara el valor nuevo con el anterior */
  toggleInput(value) {
    this.inputOld = value.replace(/\./g, '').replace('.', ',');
  }



  notification(title) {
    const Toast = Swal.mixin({
      icon: 'success',
      title: title,
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });
    Toast.fire();
  }

  findDepartament(departamentCode,departament,departamentFundCode){
    
    return departament.find(d=>d.departamentCode==departamentCode&&d.departamentFundCode==departamentFundCode)
    
  }

  findGroupByParentCode(groups: any[], parentCode) {  
    
    return groups?.find(g => g?.parentCode == parentCode);
  }

  getValue(departamentCode,departaments,field,departamentFundCode){
    return departaments?.find(d=>d.departamentCode==departamentCode&&d.departamentFundCode==departamentFundCode)?.[field]??0;
  }

  getSubTotalValue(departamentCode,field,departamentFundCode){
    const subtotal =this.subtotal;
    
    return subtotal.departaments?.find(d=>d.departamentCode==departamentCode&&d.fundCode==this.fundSelect&&d.departamentFundCode==departamentFundCode)?.[field]??0;    
  }


  /**trae los datos de los departamentos de la cuenta seleccionada */
  getDepartamentAccount() {
    this.budgetGenerateService.getDepartamentAccount(this.filter).subscribe(res => {
      this.subtotal = res.subtotal;
      this.accounts = res.accounts.map(account => ({
        ...account,
        departaments: account.departaments.sort((a, b) => Number(a.parentCode) - Number(b.parentCode))
    }));
    
      this.accountsTemp = JSON.parse(JSON.stringify(this.accounts));
      this.changeFund(this.fundSelect);     
      this.dataListAccounts = this.ngSelectData(this.accounts);      
      this.isLoading =false;
      Swal.close()
    })
  }

  getPopoverContent(d: any, a: any, group: any) {
  const value = this.getValue(
    d.departamentCode,
    this.findGroupByParentCode(a.departaments, group.parentCode)?.subDepartaments,
    'oldValue',
    d.departamentFundCode
  );

  // Mostrar popover solo si el valor es distinto de 0
  return value !== 0 ? 'Referencia presupuestaria' : null;
}


  changeFundResumen() {
    if(this.itemsTemp){
      Object.keys(this.itemsTemp).forEach(key => {
        const arr = this.itemsTemp[key];
        
        if (Array.isArray(arr) && arr.length > 0 && 'fundCode' in arr[0]) {
          this.items[key] = arr.filter(item => item.fundCode == this.fundSelect);
        }
      });
    }
   this.items={...this.items}
  }

  
  /*filtra los datos por fund*/

  changeFund(fundCode) {
    this.fundSelect=fundCode;
    if(this.accountsTemp){    
    this.accounts = this.accountsTemp.filter(d => 
      d.fundCode==this.fundSelect
    );
    this.changeFundResumen();
    this.dataListAccounts = this.ngSelectData(this.accounts);    
     
    this.setDepartmentFields();
    this.changeNgSelectAccount(); 
  }
}

getTotalFund(){
  return this.subtotal?.funds?.find(f => f.fundCode == this.fundSelect)?.valueTotal??0;
}

  




  /**Mapea los datos en formato valido para ngSelect */
  ngSelectData(data) {
    let newData = data.map((d) => {
      return {
        id: d.id,
        codeName: d.accountCode +(d.subAccountCode!='-1'?'/'+d.subAccountCode:'') + ' - ' + d.accountDisplayName?.slice(0, 30),
        name: d.accountDisplayName
      }
    });
    return newData
  }

   /**Mapea los datos en formato valido para ngSelect */
   ngSelectDataDepartament(data) {
    let newData = data.map((d) => {
      return {
        code: d?.parentCode?.toString(),
        codeName: d?.parentCode+' - '+d?.parentName,
        name: d?.parentName
      }
    });
    return newData
  }


  /**al momento de cerrar el ng select de busqueda busca actualiza la tabla */

  changeNgSelectAccount(){
    let accountFilter;
    if (this.txtFindAccount?.length==0||this.txtFindAccount==undefined) { 
      accountFilter = this.accountsTemp?.filter(d => d.fundCode==this.fundSelect ); 
    } else { 
      accountFilter = this.accountsTemp?.filter(d => this.txtFindAccount?.includes(d.id)&& d.fundCode==this.fundSelect ); 
    } 
    this.filterDepartament();
    this.accounts=accountFilter;
    this.setDepartmentFields();
  }


  filterDepartament(){
    if (this.txtFindDepartament?.length==0||this.txtFindDepartament==undefined) {
      this.fieldName=this.fieldNameTemp;
    }
    else {
      this.fieldName=this.fieldNameTemp.filter(d=>this.txtFindDepartament?.includes(d.parentCode));      
    }    
  }
  



  /*Extrae los nombres de los departamentos*/
  setDepartmentFields() {
    if (this.accounts?.length === 0) return;     
    if(this.setFirtDepartament==0){
      const first = this.accountsTemp[0];
      this.fieldName = first.departaments;
      this.fieldName.sort((a, b) => a.parentCode.localeCompare(b.parentCode));   
      this.fieldNameTemp=JSON.parse(JSON.stringify(this.fieldName));
      this.dataListDepartament=this.ngSelectDataDepartament(this.fieldNameTemp);      
      this.setFirtDepartament=1;      
    }
  }
  
  


 /**trae los datos de los departamentos de la cuenta seleccionada */
 getResumen() {
  let filter={...this.filter};
  delete filter.departamentItemCode;
  this.budgetGenerateService.getResumen(filter).subscribe(res => {
    this.items = res;
    this.itemsTemp = JSON.parse(JSON.stringify(this.items));
    this.changeFundResumen();
    this.isLoading =false;      
    Swal.close()
  })
}

findItem(itemCode){
  return this.items?.expenses?.find(i=>i.itemCode==itemCode)
}



/**exportar excel */


headers(){
  let headers = [   
    'Cuenta',
    'Nombre',
  ];
  const accountPlan=this.fieldName;
  return [...headers,...this.headerDepartament(accountPlan)]
}

capitalize(value){
  return value
    .toLowerCase()
    .split(' ')
    .map(word => 
      word
        .split('-')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join('-')
    )
    .join(' ');
}
 
headerDepartament(accountPlan){
  accountPlan.sort((a, b) => a.parentCode.localeCompare(b.parentCode));
      return accountPlan.flatMap(acc =>
        acc.subDepartaments?.map(s => s.departamentDisplayName+' ('+s.departamentCode+')') ?? []
      )
}


styleHeaderRow(worksheet, rowNumber: number): void {
  const headerRow = worksheet.getRow(rowNumber);
  worksheet.getRow(rowNumber).height = 25;
  headerRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFBFBFBF' } // gris claro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
  });
}

styleDataRow(row, accountStartIndex): void {
  row.eachCell((cell, colNumber) => {
    // Aplicar bordes a todas las celdas
    cell.border = {
      top: { style: 'thin' },
      bottom: { style: 'thin' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };

    // Si la columna es una cuenta, aplicar formato numérico
    if (colNumber >= accountStartIndex) {
      cell.numFmt = '#,##0';
    }
  });
}


autoAdjustColumns(worksheet): void {
  worksheet.columns.forEach(column => {
    let max = 10;
    column.eachCell({ includeEmpty: true }, cell => {
      const len = cell.value ? cell.value.toString().length : 10;
      if (len > max) max = len;
    });
    column.width = max + 2;
  });
}  

styleSubtotalRows(worksheet, rowNumber: number): void {
  const subtotalRow = worksheet.getRow(rowNumber);
  subtotalRow.height = 25;
  subtotalRow.eachCell(cell => {
    cell.font = { bold: true };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFBFBFBF' } // gris claro
    };
    cell.alignment = { vertical: 'middle', horizontal: 'right' };
    cell.border = {
      top: { style: 'medium' },
      bottom: { style: 'medium' },
      left: { style: 'medium' },
      right: { style: 'medium' }
    };
    cell.numFmt = '#,##0';
  });
}


addSubtotalRow(worksheet,startCol,rowNumber,mergeCol): void {
  const lastRowNumber = worksheet.lastRow.number;
  const subtotalRow = worksheet.addRow([]);
  if (mergeCol >= 1) {
    worksheet.mergeCells(subtotalRow.number, 1, subtotalRow.number, mergeCol);
    const labelCell = worksheet.getCell(subtotalRow.number, 1);
    labelCell.value = 'SUBTOTAL';
    labelCell.alignment = { horizontal: 'center', vertical: 'middle' };
    labelCell.font = { bold: true };
  }
  for (let col = startCol; col <= worksheet.columnCount; col++) {
    const colLetter = worksheet.getColumn(col).letter;
    const cell = subtotalRow.getCell(col);
    cell.value = {
      formula: `SUM(${colLetter}${rowNumber}:${colLetter}${lastRowNumber})`,
      result: null
    };
    cell.font = { bold: true };
  }
}



createSheet(workbook: Workbook, title, headers, data, accounts) {
  const colInit=this.filter?.departamentItemCode=='3'? 2: 4;
  const totalColumns =colInit + accounts.length;
  const worksheet = workbook.addWorksheet(title);

  // Título
  worksheet.mergeCells(1, 1, 1, totalColumns);
  const titleCell = worksheet.getCell('A1');
  titleCell.value = `${title.toUpperCase()}`;
  titleCell.alignment = { horizontal: 'center', vertical: 'middle' };
  titleCell.font = { bold: true };
  worksheet.getRow(1).height = 40;
  for (let col = 1; col <= totalColumns; col++) {
    worksheet.getCell(1, col).border = {
      top: { style: 'medium' },
      left: { style: 'medium' },
      bottom: { style: 'medium' },
      right: { style: 'medium' },
    };
  }
// Fila 2: encabezado general
worksheet.mergeCells(2, 1, 2, 2);
const accountCell = worksheet.getCell('A2');
accountCell.value = 'Cuentas';
accountCell.alignment = { horizontal: 'center', vertical: 'middle' };
accountCell.font = { bold: true };

worksheet.mergeCells(2, 3, 2, totalColumns);
const departamentCell = worksheet.getCell(2, 3);
departamentCell.value = 'Departamentos';
departamentCell.alignment = { horizontal: 'center', vertical: 'middle' };
departamentCell.font = { bold: true };

 

  // Encabezado principal
  worksheet.addRow(headers);
  this.styleHeaderRow(worksheet, 2);  
  this.styleHeaderRow(worksheet, 3);
  // Datos
  data.forEach(obj => {
    const row = worksheet.addRow(Object.values(obj));
    this.styleDataRow(row, 3);
  });
  this.addSubtotalRow(worksheet,3,3,2);
  this.styleSubtotalRows(worksheet, worksheet.lastRow.number);

  this.autoAdjustColumns(worksheet);
}


exportToExcel(): void {
  const workbook = new Workbook();
  const data = this.dataExcel(this.accounts,this.fieldName);
  this.createSheet(workbook,this.accounts[0].itemDisplayName,this.headers(),data,this.fieldName);
  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([buffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    this.saveExcelFile(blob, this.accounts[0]?.itemName+'_'+this.getDate());
  });
}

setCode(accounts){
  return accounts.subAccountCode!='-1'?accounts.accountCode+" / "+accounts.subAccountCode:accounts.accountCode.toString();
}

setName(accounts){
  return accounts.subAccountCode!='-1'?accounts.accountDisplayName+" - "+accounts.subAccountName:accounts.accountDisplayName;
}

dataExcel(data,plan) {
  const result = data.map(e => {
    const fixedDataValues = [  
      this.setCode(e),
      this.setName(e)
    ];  
    const accountsValues = this.flattenAccounts(e.departaments);
    
    const result2 = [...fixedDataValues, ...accountsValues];
    return result2
  });
  return result;
}


orderByParentCode(accounts){
  return accounts.sort((a, b) => a.parentCode.localeCompare(b.parentCode));
}


flattenAccounts(accounts) {
  accounts=this.orderByParentCode(accounts);
  const accountMap = accounts.flatMap(acc =>
    (acc.subDepartaments ?? [])
      .sort((a, b) => a.departamentFundCode.localeCompare(b.departamentFundCode))
      .map(s => s.value ?? 0)
  );

  return accountMap;
}




private saveExcelFile(buffer: any, fileName: string): void {
  const data: Blob = new Blob([buffer], { type: this.EXCEL_TYPE });
  saveAs(data, `${fileName}.xlsx`);
}


/**Obtener la fecha en formato 04/12/2024 09:36:44  */
getDate() {
  let date = new Date();
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' } as const; // Opciones para la fecha
  const formattedDate = date.toLocaleDateString('es-ES', options); // Formato DD-MM-YYYY
  const formattedTime = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit', second: '2-digit' }); // Formato HH:mm:ss
  return `${formattedDate}_${formattedTime}`;
}


}
